import { Card, Divider, Stack, Text, Title } from '@mantine/core';
import { AuditLogActions } from '../../../enums/retrieve-audit-logs.enum';
import { formatDate } from '../../../helpers/date-convert';
import { BasicAuditLog } from '../../../type/retrieve-audit-logs.types';

interface Props {
  selectedLog: BasicAuditLog;
}
function LogsExportDetails(props: Props) {
  const { selectedLog } = props;

  const getChangeMessage = () => {
    let data: JSX.Element = <></>;

    if (selectedLog.logActionId === AuditLogActions.EXPORT_TRANSACTIONS) {
      data = (
        <Text size='sm'>
          <strong>{selectedLog.details[0].originUsername}</strong> exported{' '}
          <strong>{selectedLog.details[0].targetUsername}'s</strong>{' '}
          transactions from
          <strong>
            {' ' +
              formatDate(selectedLog.details[0].dateFrom!.toString()) +
              ' '}
          </strong>
          to
          <strong>
            {' ' + formatDate(selectedLog.details[0].dateTo!.toString())}
          </strong>
        </Text>
      );
    } else if (selectedLog.logActionId === AuditLogActions.EXPORT_FILES) {
      data = (
        <Text size='sm'>
          <strong>{selectedLog.details[0].originUsername}</strong> exported{' '}
          <strong>{selectedLog.details[0].targetMerchantName}'s</strong>{' '}
          onboarding files
        </Text>
      );
    } else if (selectedLog.logActionId === AuditLogActions.CREATE_POS) {
      data = (
        <Text size='sm'>
          <strong>{selectedLog.details[0].originUsername}</strong> created a POS
          named <strong>{selectedLog.details[0].posName}</strong> for{' '}
          <strong>{selectedLog.details[0].targetMerchantName}</strong>
        </Text>
      );
    } else if (selectedLog.logActionId === AuditLogActions.UNASSIGN_MID) {
      data = (
        <>
          {data}
          {selectedLog.details.map((detail) => {
            return (
              <>
                <Text size='sm'>
                  Unassigned MID <br /> <strong>{detail.midName}</strong> from{' '}
                  <strong>{detail.posName}</strong>
                </Text>
              </>
            );
          })}
        </>
      );
    } else if (selectedLog.logActionId === AuditLogActions.ASSIGN_MID) {
      data = (
        <>
          {data}
          {selectedLog.details[0].posNames?.map((posName) => {
            return [
              <Text size='sm'>
                Assigned MID
                <br />
                <strong>{selectedLog.details[0].midName}</strong> to{' '}
                <strong>{posName}</strong>
              </Text>,
            ];
          })}
        </>
      );
    } else if (selectedLog.logActionId === AuditLogActions.CREATE_MID) {
      data = (
        <>
          {selectedLog.details.map((detail) => {
            return (
              <>
                <Text size='sm'>
                  <strong>{selectedLog.details[0].originUsername}</strong>{' '}
                  created a MID named <strong>{detail.midName}</strong> for{' '}
                  <strong>{detail.targetMerchantName}</strong>
                </Text>
              </>
            );
          })}
        </>
      );
    } else if (selectedLog.logActionId === AuditLogActions.LOGIN) {
      data = (
        <Text size='sm'>
          <strong>{selectedLog.details[0].originUsername}</strong> logged in
        </Text>
      );
    } else if (selectedLog.logActionId === AuditLogActions.LOGOUT) {
      data = (
        <Text size='sm'>
          <strong>{selectedLog.details[0].originUsername}</strong> logged out
        </Text>
      );
    }

    return data;
  };
  return (
    <>
      <Card withBorder p='xl' sx={{ width: '100%' }}>
        <Stack>
          <Title order={4}>Description</Title>
          <Divider />
          {getChangeMessage()}
        </Stack>
      </Card>
    </>
  );
}

export default LogsExportDetails;
